export default __webpack_public_path__ + "static/SR USA - Best Used Within - Statement-626a75eb76fcb49ab0918aa936bd0823.pdf";